import type { ActionLog } from "../ActionLog.type"
import { ActionType } from "./ActionType"

export default function isActionTypeGamePlay(actionLog: ActionLog): boolean {
  return actionLog.action.type >= ActionType.Game.StartRound
}